<div
  class="bva-info-container pad all-1x pad top-3x"
  data-cy="info.bva-info-container"
>
  <h4>{{ 'bva_info_hello' | translate }} {{ msa.msaFirstName }}!</h4>
  <div class="eyebrow">
    {{ 'bva_info_associate_number' | translate }} {{ msa.msaId }}
  </div>
</div>
